import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import styles from './Tooltip.css';

const TooltipComponent = props => {
  const { content } = props;
  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      className={styles.tooltip}
      placement="bottom"
      overlay={<Popover id="popover-contained">{content}</Popover>}
    >
      <span className={`${styles['badge-summary']}`}>i</span>
    </OverlayTrigger>
  );
};

TooltipComponent.defaultProps = {
  content: '',
};

export default TooltipComponent;
